import type { TOC } from '@ember/component/template-only'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'
import { Tooltip } from 'teacher-ui-client/components/tooltip'
import type { SafeString } from '@ember/template'

interface Signature {
  Element: HTMLSpanElement
  Args: {
    tooltipContent?: string | SafeString
  }
}

export const ChartInfoTooltip: TOC<Signature> = <template>
  {{#if @tooltipContent}}
    <span class="z-tooltip absolute top-0 right-1 print:hidden" data-test-chart-tooltip ...attributes>
      <PhosphorIcon @icon="phosphor-info-fill" class="text-dusty-black-500 h-3 w-3 cursor-pointer" />
      <Tooltip @text={{@tooltipContent}} data-test-tooltip />
    </span>
  {{/if}}
</template>

export default ChartInfoTooltip
